import { getGrowthFeatureDefaults } from "./growth-feature-defaults-copy";

export type SeoAuditsMetricIcon = "speed" | "score" | "traffic" | "rankings";

export type GrowthFeatureSeoAuditsMetricCopy = {
  label: string;
  before: string;
  after: string;
  icon: SeoAuditsMetricIcon;
};

export type GrowthFeatureSeoAuditsDemoCopy = {
  srOnlyIntro: string;
  metricImproved: string;
  metrics: GrowthFeatureSeoAuditsMetricCopy[];
};

export type GrowthFeatureSeoAuditsCardCopy = {
  title: string;
  description: string;
  badge: string;
  demo: GrowthFeatureSeoAuditsDemoCopy;
};

export const DEFAULT_GROWTH_FEATURE_SEO_AUDITS_COPY: GrowthFeatureSeoAuditsCardCopy = getGrowthFeatureDefaults("en").seoAudits as GrowthFeatureSeoAuditsCardCopy;

export function formatSeoAuditMetricImproved(
  template: string,
  metric: Pick<GrowthFeatureSeoAuditsMetricCopy, "label" | "before" | "after">,
): string {
  return template
    .replace("{label}", metric.label)
    .replace("{before}", metric.before)
    .replace("{after}", metric.after);
}
